import { Navigate, NavLink, Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import {
  LayoutDashboard,
  Package,
  Server,
  Users,
  Wallet,
  Send,
  UserSquare2,
  HelpCircle,
  BookOpen,
  ScrollText,
  Tag,
  Percent,
  MessageSquare,
  ClipboardList,
} from 'lucide-react';
import { authApi } from '@/api';
import { cn } from '@/lib/utils';

const items = [
  { to: '/admin', icon: LayoutDashboard, label: 'Дашборд', end: true },
  { to: '/admin/products', icon: Package, label: 'Товары' },
  { to: '/admin/categories', icon: Tag, label: 'Категории' },
  { to: '/admin/servers', icon: Server, label: 'Серверы' },
  { to: '/admin/users', icon: Users, label: 'Пользователи' },
  { to: '/admin/transactions', icon: Wallet, label: 'Транзакции' },
  { to: '/admin/deliveries', icon: Send, label: 'Доставки' },
  { to: '/admin/team', icon: UserSquare2, label: 'Команда' },
  { to: '/admin/faq', icon: HelpCircle, label: 'FAQ' },
  { to: '/admin/wiki', icon: BookOpen, label: 'Вики' },
  { to: '/admin/applications', icon: ClipboardList, label: 'Заявки' },
  { to: '/admin/rules', icon: ScrollText, label: 'Правила' },
  { to: '/admin/promos', icon: Percent, label: 'Промокоды' },
  { to: '/admin/templates', icon: MessageSquare, label: 'Сообщения бота' },
];

export function AdminLayout() {
  const { data: me, isLoading } = useQuery({ queryKey: ['me'], queryFn: authApi.me, retry: false });

  if (isLoading) return <div className="p-12 text-eol-desc">Загрузка…</div>;
  if (!me) return <Navigate to="/login" replace />;
  if (me.role !== 'admin') return <Navigate to="/" replace />;

  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-12 py-12 grid lg:grid-cols-[220px_1fr] gap-8">
      <aside>
        <h2 className="text-xs font-bold uppercase tracking-widest text-eol-desc mb-3">
          Админ-панель
        </h2>
        <nav className="space-y-1">
          {items.map((i) => (
            <NavLink
              key={i.to}
              to={i.to}
              end={i.end}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2 px-3 py-2 rounded-md text-sm font-semibold transition',
                  isActive
                    ? 'bg-eol-pink/15 text-eol-pink ring-1 ring-eol-pink/30'
                    : 'text-eol-desc hover:text-eol-white hover:bg-white/5',
                )
              }
            >
              <i.icon className="h-4 w-4" />
              {i.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <section className="min-w-0">
        <Outlet />
      </section>
    </div>
  );
}
